import type { RouteRecordRaw } from 'vue-router';

export const INVENTORY_DETAIL_ROUTER: RouteRecordRaw[] = [
  {
    path: '/inventory/detail',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/inventory/detail/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/inventory/detail/views/List.vue'),
        name: 'Inventory Detail List',
        meta: {
          title: '아이템별 재고조회',
        },
      },
    ],
  },
];
